import React from 'react'
import '../../Css/PhotoUserTemplate.scss'
import DummyPict from '../../Assets/Template/userProfile.png'

function PhotoUser() {
    return (
        <div className="photoWrapper">
                <img src={DummyPict} alt="" srcset=""/>
        </div>
    )
}

export default PhotoUser
